var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconMindmap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.236,
    height: 61.238,
    viewBox: "0 0 61.236 61.238",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brain-circuit-20-regular",
    transform: "translate(-19.2 -19.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6460",
    "data-name": "Group 6460",
    transform: "translate(19.2 19.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11693",
    "data-name": "Path 11693",
    d: "M35.007,22.232A14.965,14.965,0,0,1,44.077,19.2a6.724,6.724,0,0,1,5.741,2.985A6.725,6.725,0,0,1,55.559,19.2a14.965,14.965,0,0,1,9.071,3.035,10.9,10.9,0,0,1,4.107,6.338,6.071,6.071,0,0,1,3.368,1.4,10.952,10.952,0,0,1,3.2,4.849,15.469,15.469,0,0,1,.245,9.836,6.359,6.359,0,0,1,.811.459A7.286,7.286,0,0,1,78.8,48c1.16,2.315,1.638,5.546,1.638,9.469,0,4.367-1.665,7.3-3.778,9.109A10.257,10.257,0,0,1,72.625,68.7a15.509,15.509,0,0,1-3.135,6.705,12.746,12.746,0,0,1-10.1,5.025,11.7,11.7,0,0,1-8.32-3.942,16.276,16.276,0,0,1-1.248-1.474,16.248,16.248,0,0,1-1.248,1.474,11.693,11.693,0,0,1-8.32,3.942,12.752,12.752,0,0,1-10.1-5.025A15.527,15.527,0,0,1,27.011,68.7a10.257,10.257,0,0,1-4.034-2.124c-2.113-1.81-3.778-4.746-3.778-9.109,0-3.923.482-7.157,1.638-9.469a7.351,7.351,0,0,1,2.442-2.89,6.047,6.047,0,0,1,.811-.452,15.48,15.48,0,0,1,.245-9.84,10.952,10.952,0,0,1,3.2-4.849,6.1,6.1,0,0,1,3.368-1.4,10.927,10.927,0,0,1,4.11-6.338Zm12.9,6.533v-.038l-.008-.191a10.5,10.5,0,0,0-.589-2.924,4.677,4.677,0,0,0-1.183-1.875,2.909,2.909,0,0,0-2.048-.712,11.137,11.137,0,0,0-6.721,2.227,6.814,6.814,0,0,0-2.847,5.427,1.914,1.914,0,0,1-2.518,1.814,2.025,2.025,0,0,0-2.048.448,7.248,7.248,0,0,0-2.005,3.165c-1.068,2.993-.957,6.617.509,8.822a1.914,1.914,0,0,1,.321,1.06h2.87A8.611,8.611,0,0,1,40.25,54.6v1.282a5.741,5.741,0,1,1-3.827,0V54.6a4.786,4.786,0,0,0-4.784-4.784h-6.7a1.91,1.91,0,0,1-.67-.122l-.011.023c-.758,1.512-1.232,4.022-1.232,7.754,0,3.288,1.206,5.14,2.442,6.2a5.872,5.872,0,0,0,3.3,1.454,1.914,1.914,0,0,1,1.914,1.914,10.8,10.8,0,0,0,2.449,5.982,8.957,8.957,0,0,0,7.119,3.586,7.9,7.9,0,0,0,5.55-2.756,11.722,11.722,0,0,0,1.673-2.208,6.02,6.02,0,0,0,.432-.9V40.247H43.752a5.741,5.741,0,1,1,0-3.827H47.9Zm3.827,38.269v3.7a6.028,6.028,0,0,0,.432.9,12.02,12.02,0,0,0,1.669,2.208A7.92,7.92,0,0,0,59.386,76.6,8.957,8.957,0,0,0,66.5,73.016a10.8,10.8,0,0,0,2.449-5.982,1.914,1.914,0,0,1,1.914-1.914,5.872,5.872,0,0,0,3.3-1.454c1.236-1.06,2.442-2.913,2.442-6.2,0-3.732-.478-6.238-1.232-7.754A3.532,3.532,0,0,0,74.228,48.3a2.514,2.514,0,0,0-1.447-.394,1.914,1.914,0,0,1-1.592-2.974c1.47-2.2,1.577-5.829.509-8.822a7.225,7.225,0,0,0-2.005-3.165,2.017,2.017,0,0,0-2.048-.448,1.914,1.914,0,0,1-2.518-1.814,6.808,6.808,0,0,0-2.851-5.427,11.137,11.137,0,0,0-6.717-2.227,2.909,2.909,0,0,0-2.048.712,4.669,4.669,0,0,0-1.186,1.875,9.871,9.871,0,0,0-.593,3.115V63.211H54.6a4.786,4.786,0,0,0,4.784-4.784V51.4a5.741,5.741,0,1,1,3.827,0v7.023A8.611,8.611,0,0,1,54.6,67.038h-2.87Zm-15.309-28.7a1.914,1.914,0,1,0,1.914-1.914A1.914,1.914,0,0,0,36.423,38.334ZM61.3,47.9a1.914,1.914,0,1,0-1.914-1.914A1.914,1.914,0,0,0,61.3,47.9ZM38.336,59.384A1.914,1.914,0,1,0,40.25,61.3,1.914,1.914,0,0,0,38.336,59.384Z",
    transform: "translate(-19.2 -19.196)",
    fill: "#f2f7fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    transform: "translate(32.318 31.815)",
    fill: "none",
    stroke: "#f69139",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_299",
    "data-name": "Ellipse 299",
    transform: "translate(32.318 54.815)",
    fill: "none",
    stroke: "#f69139",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    transform: "translate(55.318 39.815)",
    fill: "none",
    stroke: "#f69139",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.5,
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMindmap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-mindmap.fc84c867.svg";
export { ForwardRef as ReactComponent };